export const ClientDetailSkeleton: React.FC = () => {
    return (
        <div className="w-full">
            <div className="skeleton-box w-full h-40 bg-white flex justify-center items-center flex-col transform transition-all hover:shadow-soft hover:-translate-y-1 mb-8"></div>
            <div className="px-6">
                <div className="skeleton-box w-full rounded-md h-80 bg-white flex justify-center items-center flex-col transform transition-all hover:shadow-soft hover:-translate-y-1 mb-8"></div>
            </div>
        </div>
    );
};